const getPieveActivityEventSeq = (event = {}) => {
  const seq = Number(event?.seq);

  if (Number.isFinite(seq) && seq > 0) {
    return seq;
  }

  return null;
};

export default getPieveActivityEventSeq;
